
import React, { useEffect } from "react";
import "../Styles/Terms.css"; // <-- create this css file

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="terms-container">
        <h1>Terms and Conditions</h1>

        <p>Welcome to WEGO HOLIDAY HOMES LTD</p>

        <p>
          These terms and conditions outline the rules and regulations for the
          use of Wego Holiday Homes’ website. By accessing this website, we
          assume you accept these terms and conditions. Do not continue to use
          Wego Holiday Homes if you do not agree to take all of the terms and
          conditions stated on this page.
        </p>

        <section>
          <h2>Terminology</h2>
          <p>
            The following terminology applies to these Terms and Conditions,
            Privacy Statement and Disclaimer Notice and all Agreements:
          </p>
          <p>
            “Client”, “You” and “Your” refers to you, the person using this
            website and compliant with the Company’s terms and conditions.
            “The Company”, “Ourselves”, “We”, “Our” and “Us”, refers to Wego
            Holiday Homes. “Party”, “Parties”, or “Us”, refers to both the
            Client and ourselves.
          </p>
          <p>
            All terms refer to the offer, acceptance and consideration of
            payment necessary to undertake the process of our assistance to the
            Client in the most appropriate manner for the express purpose of
            meeting the Client’s needs in respect of provision of the Company’s
            stated services, in accordance with applicable law.
          </p>
        </section>

        <section>
          <h2>License</h2>
          <p>
            Unless otherwise stated, Wego Holiday Homes and/or its licensors own
            the intellectual property rights for all material on Wego Holiday
            Homes. All intellectual property rights are reserved. You may access
            this from Wego Holiday Homes for your own personal use subject to
            restrictions set in these terms and conditions.
          </p>

          <h3>You must not:</h3>
          <ul>
            <li>Republish material from Wego Holiday Homes</li>
            <li>Sell, rent or sub-license material from Wego Holiday Homes</li>
            <li>Reproduce, duplicate or copy material from Wego Holiday Homes</li>
            <li>Redistribute content from Wego Holiday Homes</li>
          </ul>

          <p>This Agreement shall begin on the date hereof.</p>
        </section>

        <section>
          <h2>User Comments</h2>
          <p>
            Parts of this website offer an opportunity for users to post and
            exchange opinions and information. Wego Holiday Homes does not
            filter, edit, publish or review Comments prior to their presence on
            the website. Comments do not reflect the views and opinions of Wego
            Holiday Homes, its agents and/or affiliates. Comments reflect the
            views and opinions of the person posting them.
          </p>

          <p>
            To the extent permitted by applicable laws, Wego Holiday Homes shall
            not be liable for Comments or for any liability, damages or expenses
            caused and/or suffered as a result of any use of or appearance of
            Comments on this website.
          </p>

          <p>
            Wego Holiday Homes reserves the right to monitor all Comments and to
            remove any Comments considered inappropriate, offensive, or in
            breach of these Terms and Conditions.
          </p>

          <h3>You warrant and represent that:</h3>
          <ul>
            <li>You are entitled to post the Comments and have all necessary licenses and consents</li>
            <li>The Comments do not invade any intellectual property right of any third party</li>
            <li>The Comments do not contain defamatory, libelous, offensive or unlawful material</li>
            <li>The Comments will not be used to promote unlawful activity</li>
          </ul>

          <p>
            You hereby grant Wego Holiday Homes a non-exclusive license to use,
            reproduce, edit and authorize others to use and reproduce your
            Comments in any form or media.
          </p>
        </section>

        <section>
          <h2>Hyperlinking to Our Content</h2>

          <h3>Organizations that may link without approval:</h3>
          <ul>
            <li>Government agencies</li>
            <li>Search engines</li>
            <li>News organizations</li>
            <li>Online directory distributors</li>
            <li>System-wide Accredited Businesses</li>
          </ul>

          <p>Links must not be deceptive or imply endorsement.</p>

          <h3>Organizations requiring approval:</h3>
          <ul>
            <li>Consumer/business information sources</li>
            <li>Dot.com community sites</li>
            <li>Charitable associations</li>
            <li>Internet portals</li>
            <li>Consulting firms and educational institutions</li>
          </ul>

          <p>
            Approved organizations may link by using our corporate name, URL, or
            a descriptive reference. No use of Wego Holiday Homes’ logo is
            allowed without a trademark license.
          </p>
        </section>

        <section>
          <h2>iFrames</h2>
          <p>
            Without prior approval and written permission, you may not create
            frames around our pages that alter our website’s appearance.
          </p>
        </section>

        <section>
          <h2>Reservation of Rights</h2>
          <p>
            We reserve the right to request removal of any link to our website
            and may amend these terms at any time. By continuing to link, you
            agree to follow our linking requirements.
          </p>
        </section>

        <section>
          <h2>Removal of Links</h2>
          <p>
            If you find any link on our website offensive, contact us. We may
            consider requests but are not obligated to respond. We do not
            guarantee that information on this website is correct or complete.
          </p>
        </section>

        <section>
          <h2>Disclaimer</h2>
          <p>
            To the maximum extent permitted by law, we exclude all warranties
            and conditions relating to our website. Nothing in this disclaimer
            will limit liability for death, personal injury, or fraud.
          </p>
          <p>
            As long as the website is provided free of charge, we will not be
            liable for any loss or damage.
          </p>
        </section>

        {/* ----------------------------- PRIVACY POLICY ---------------------------- */}

        <h1 className="mt-60">Privacy Policy for WEGO HOLIDAY HOMES LTD</h1>

        <section>
          <p>
            At Wego Holiday Homes Ltd, one of our top priorities is the privacy
            of our visitors. This Privacy Policy outlines the types of
            information collected and how we use it.
          </p>

          <p>
            If you have additional questions, contact us through email. This
            policy applies only to online activities.
          </p>
        </section>

        <section>
          <h2>Consent</h2>
          <p>
            By using our website, you hereby consent to our Privacy Policy and
            agree to its terms.
          </p>
        </section>

        <section>
          <h2>Information We Collect</h2>
          <p>
            You will be informed whenever personal information is requested. If
            you contact us directly, we may receive additional details such as
            name, email, phone number, message content, and attachments.
          </p>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <ul>
            <li>Provide, operate, and maintain our website</li>
            <li>Improve and personalize the website</li>
            <li>Understand usage trends</li>
            <li>Develop new features and services</li>
            <li>Communicate updates or marketing messages</li>
            <li>Send emails</li>
            <li>Prevent fraud</li>
          </ul>
        </section>

        <section>
          <h2>Log Files</h2>
          <p>
            Wego Holiday Homes follows standard log file procedures. These logs
            record IP addresses, browser details, timestamps, ISP, referring
            pages, and click counts. This information is not personally
            identifiable and is used for analytics and security.
          </p>
        </section>

        <section>
          <h2>Cookies and Web Beacons</h2>
          <p>
            Like most websites, Wego Holiday Homes uses cookies to store
            preferences and optimize user experience.
          </p>
        </section>

        <section>
          <h2>CCPA Privacy Rights</h2>
          <p>California consumers have the right to:</p>
          <ul>
            <li>Request disclosure of personal data collected</li>
            <li>Request deletion of personal data</li>
            <li>Request that personal data not be sold</li>
          </ul>
        </section>

        <section>
          <h2>GDPR Data Protection Rights</h2>
          <p>Every user has:</p>
          <ul>
            <li>The right to access</li>
            <li>The right to rectification</li>
            <li>The right to erasure</li>
            <li>The right to restrict processing</li>
            <li>The right to object</li>
            <li>The right to data portability</li>
          </ul>
        </section>

        <section>
          <h2>Children’s Information</h2>
          <p>
            Wego Holiday Homes does not knowingly collect personal information
            from children under 13. If such information is discovered, we will
            remove it immediately.
          </p>
        </section>

        {/* ----------------------------- ABOUT US ---------------------------- */}

        <h1 className="mt-60">About Us — Wego Holiday Homes Ltd</h1>

        <section>
          <h2>Where Luxury Living Meets the Comfort of Home in Dubai</h2>
          <p>
            Welcome to Wego Holiday Homes Ltd, a boutique short-stay brand
            delivering elevated, design-led living spaces across Dubai’s most
            prestigious neighbourhoods. From Downtown Dubai to Dubai Marina and
            JBR, our homes are crafted for guests seeking comfort,
            sophistication, and lifestyle in one seamless experience.
          </p>

          <p>
            At Wego Holiday Homes, luxury isn’t just an aesthetic — it’s the
            feeling you get when everything has been thoughtfully designed for
            your comfort.
          </p>
        </section>

        <section>
          <h2>Who We Are</h2>
          <p>
            We are a family-driven hospitality company with years of experience
            hosting guests across the UK and UAE. Our background includes luxury
            fashion, interior styling, and property management.
          </p>

          <ul>
            <li>High-end interiors</li>
            <li>Five-star comfort</li>
            <li>Hotel-quality amenities</li>
            <li>Warm, personal service</li>
          </ul>
        </section>

        <section>
          <h2>What Makes Our Homes Special</h2>

          <h3>✨ Premium Locations</h3>
          <p>All properties are located in Dubai’s top neighbourhoods.</p>

          <h3>✨ Elegant Interiors</h3>
          <p>
            Each home is individually designed with luxury aesthetics — calm
            neutrals, premium textures, curated décor, and modern furnishings.
          </p>

          <h3>✨ High-Standard Comfort</h3>
          <ul>
            <li>Plush bedding & luxury linen</li>
            <li>Five-star housekeeping</li>
            <li>High-speed WiFi</li>
            <li>Smart TVs</li>
            <li>Fully equipped kitchens</li>
            <li>High-quality toiletries</li>
            <li>Balcony/view apartments where available</li>
          </ul>

          <h3>✨ Seamless Guest Experience</h3>
          <ul>
            <li>Smooth digital check-in</li>
            <li>24/7 guest support</li>
            <li>Clear communication</li>
            <li>Personal touches</li>
          </ul>
        </section>

        <section>
          <h2>Designed for Every Kind of Luxury Traveller</h2>

          <ul>
            <li>Business executives</li>
            <li>Digital nomads</li>
            <li>Global families</li>
            <li>Couples</li>
            <li>Travellers seeking premium stays</li>
          </ul>
        </section>

        <section>
          <h2>Our Philosophy</h2>
          <p>
            Luxury should feel effortless. Every Wego home is carefully chosen,
            professionally maintained, and intentionally designed to create a
            memorable experience.
          </p>
        </section>

        <h2>Your Home in Dubai’s Most Iconic Locations</h2>
        <p>Thank you for choosing Wego Holiday Homes Ltd.</p>
        <p>
          We’re honored to create a space where your Dubai story unfolds —
          beautifully, comfortably, and luxuriously.
        </p>
      </div>
    </>
  );
};

export default TermsAndConditions;
